import { css } from 'styled-components';

export const fitImg = css`
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
`;
